<template>
  <v-autocomplete
    v-model="model"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-slot:selection="{ item, index }">
      <v-chip v-if="chips && index === 0" small>{{ getSelectionLabel(item) }}</v-chip>
      <span v-else-if="index === 0" class="collapsed-autocomplete__label">{{ getSelectionLabel(item) }}</span>
      <span v-if="index === 1 && Array.isArray(value)" class="grey--text caption ml-1 flex-shrink-0">
        (+{{ value.length - 1 }} {{ $t("components.select.others") }})
      </span>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: 'OCollapsedAutocomplete',
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Object, Array],
      default: () => [],
    },
    chips: {
      type: Boolean,
      default: false,
    },
    selectionText: {
      type: [String, Function],
      default: null,
    },
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    getSelectionLabel(item) {
      const text = this.selectionText ?? this.$attrs['item-text']
      if (typeof text === 'function') return text(item)
      if (typeof text === 'string') return item[text]
      return item
    },
  },
}
</script>

<style scoped>
.collapsed-autocomplete__label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}
</style>
